const brandOverrides = {
  clearly: 'cle-ca',
  vdfr: 'vde-fr',
  'vd-fr': 'vde-fr',
}

export const normalizeBrand = (brand: string): string => {
  const brandLowerCase = brand?.trim()?.toLowerCase()
  if (brandOverrides[brandLowerCase]) return brandOverrides[brandLowerCase]
  return brandLowerCase
}

const TOPOLOGY_HOST_PATTERN = /^ui\.iris-(.+)-(?:dev|test|stage|prod)(?:\.|$)/

export const normalizeBrandFromHost = (hostUrl: string): string | undefined => {
  const host = hostUrl
    ?.trim()
    ?.toLowerCase()
    ?.replace(/^[a-z][a-z0-9+.-]*:\/\//, '')
    ?.split(/[/?#:]/)[0]

  if (host?.startsWith('ui.directbilling-')) return 'cle-ca'

  const brand = host?.match(TOPOLOGY_HOST_PATTERN)?.[1]
  const result = brand ? normalizeBrand(brand) : undefined
  return result
}
